$(document).ready(function () {
	// POPUP BANNER
	var POPUP_DELAY_MS = 1500;
	var $popup = $('.JSfirst-popup');

	if ($('body').attr('id') === 'start-page' && $popup.length && !sessionStorage.getItem('popup')) {

		setTimeout(function(){ 
			var $popupImage = $popup.find('.first-popup-inner img');
			if (!$popupImage.attr('src') && $popupImage.data('src')) {
				$popupImage.attr('src', $popupImage.data('src'));
			}
			$popup.animate({ top: '50%' }, 700);
		}, POPUP_DELAY_MS);   

		$(document).on('click', function(e){
			var target = $(e.target);
			if(!target.is($('.first-popup-inner img'))) { 
				$popup.hide();
				sessionStorage.setItem('popup', '1');
				$(document).off('click');
			} 
		}); 
	}
});
